export default "__VITE_ASSET__BilraNMk__"